// biome-ignore lint/correctness/noUnusedImports:
import React from "react";
import { MathfieldElement } from "mathlive";

const MATHFIELD_DIALOG_ID = "mathfield-dialog";
const MATHFIELD_INPUT_ID = "mathfield-input";

export const getMathfieldInputId = ({ mathfieldId }: { mathfieldId: string }) => {
    return `${MATHFIELD_INPUT_ID}-${mathfieldId}`;
};

export const getMathfieldDialogId = ({ mathfieldId }: { mathfieldId: string }) => {
    return `${MATHFIELD_DIALOG_ID}-${mathfieldId}`;
};

export const getMathfieldInputEl = ({ mathfieldId }: { mathfieldId: string }) => {
    return document.getElementById(getMathfieldInputId({ mathfieldId: mathfieldId })) as MathfieldElement | null;
};

export const getMathfieldDialogEl = ({ mathfieldId }: { mathfieldId: string }) => {
    return document.getElementById(getMathfieldDialogId({ mathfieldId: mathfieldId })) as HTMLDialogElement | null;
};
